exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n\n/* Sync for Science Discovery TimeSeries Stylesheet */\n\n/* v.01.02 Updated 5/13/2019 */\n\n.mark {\n   cursor: pointer\n}", ""]);

// exports
